// @material-ui/core
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import {
  Email as MailIcon,
  VerifiedUser as UserIcon
} from "@material-ui/icons";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Caba from "../services/Caba";

const styles = theme => ({
  root: {
    width: "100%",
    background: theme.palette.background.paper
  },
  avatar: {
    width: 24,
    height: 24
  },
  card: {
    borderTop: `${theme.spacing.unit}px solid ${theme.palette.primary.main}`
  }
});

class Profile extends Component {
  state = {
    profile: Caba.getProfile()
  };

  render() {
    const { classes } = this.props;
    const profile = this.state.profile;
    return (
      <Grid container>
        <Grid item xs={12} md={6} lg={4}>
          <Typography variant="headline">Your profile</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={8}>
          <Card className={classes.card}>
            <CardContent>
              <Typography gutterBottom variant="headline" component="h2">
                Information
              </Typography>
              <Typography component="p">
                Manage this basic information – your name, email and phone
                number – to help us keep in touch.
              </Typography>
              <List className={classes.root}>
                <ListItem button>
                  <ListItemIcon>
                    <Avatar
                      alt={profile.name}
                      src={profile.imageUrl}
                      className={classes.avatar}
                    />
                  </ListItemIcon>
                  <ListItemText inset primary={profile.name} secondary="Name" />{" "}
                  {/* <ExpandIcon/> */}
                </ListItem>
                <ListItem button>
                  <ListItemIcon>
                    <MailIcon />
                  </ListItemIcon>
                  <ListItemText
                    inset
                    primary={profile.email}
                    secondary="Email"
                  />{" "}
                  {/* <ExpandIcon/> */}
                </ListItem>
                <ListItem button>
                  <ListItemIcon>
                    <UserIcon />
                  </ListItemIcon>
                  <ListItemText
                    inset
                    primary={profile.googleId}
                    secondary="Google ID"
                  />{" "}
                  {/* <ExpandIcon/> */}
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Profile);



// WEBPACK FOOTER //
// ./src/pages/Profile.js